import {styled} from "@mui/material";

export const ShippingMethodSelectorContainer = styled('div')(() => ({
    padding: '1rem',
    '& Button': {
        padding: 'unset'
    }
}));

export const ShippingMethodContainer = styled('div')(({theme}) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    padding: '0.5rem 1rem',
    borderRadius: '0.5rem',
    cursor: 'pointer',

    '&:hover': {
        background: theme.barekam.grey
    }
}));

export const ShippingMethodContainerSelected = styled(ShippingMethodContainer)(({theme}) => ({
    border: `0.15rem solid ${theme.barekam.green}`,
    padding: '0.35rem 0.90rem',
}));

export const ShippingMethodTextContainer = styled('div')(({}) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start'
}));


